<template>
  <van-popup v-model="categoryVisibleForMobile" position="right" :style="{ width: '100%',height: '100%', boxSizing: 'border-box' }" closeable>
    <div style="padding-top: .8rem;height: 100%">
      <van-tree-select height="100%" :items="categoryTree" :main-active-index.sync="categoryTreeActive">
        <template #content>
          <div class="categoryPopupContent f fw-w">
            <a :href="'/product-list/' + categoryTree[categoryTreeActive].categoryUrl" target="_blanck">
              <div class="viewAll" @click="toCategoryDetailForViewAll">{{$t('Home.Mobile.ViewAll')}}</div>
            </a>
            <div v-for="secondItem in categoryTreeActiveTree" :key="secondItem.id" class="second_item" style="width: 100%;">
              <a class="f-b-c" style="text-decoration: none; margin-bottom: 0.4rem;" :href="'/product-list/' + secondItem.categoryUrl" target="_blanck">
                <span class="second_item_name">{{ secondItem.name }}</span>
                <span style="color:#909399; " class="el-icon-arrow-right" ></span>
              </a>
              <div class="f" style="flex-wrap: wrap;">
                <a v-for="item in secondItem.childList" :key="item.id" :href="'/product-list/' + item.categoryUrl" class="item">
                  <div class="image">
                    <oss-img v-if="item.imgUrl" :width="50" :height="50" :src="item.imgUrl" />
                    <img v-else :width="50" src="@/assets/img/icon/noPictureFound.png" />
                  </div>
                  <span target="_blanck">
                    <div class="item_name">{{ item.name }}</div>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
  </van-popup>
</template>

<script>
import icon from 'vant/lib/icon'
import 'vant/lib/icon/style'
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
// import Collapse from 'vant/lib/collapse'
import 'vant/lib/collapse/style'
// import CollapseItem from 'vant/lib/collapse-item'
import 'vant/lib/collapse-item/style'
import TreeSelect from 'vant/lib/tree-select'
import 'vant/lib/tree-select/style'
import bus from '@/util/bus'
export default {
  components: {
    'van-icon': icon,
    'van-popup': popup,
    'van-tree-select': TreeSelect
  },
  data() {
    return {
      categoryVisibleForMobile: false,
      categoryTreeActive: 0
    }
  },
  computed: {
    categoryTree() {
      const categoryTree = this.$store.state.common.categoryTree
      if (categoryTree.length === 0) this.$store.dispatch('common/getCategoryTree')
      categoryTree.forEach((e) => {
        e.text = e.name
        if (e.childList) {
          e.childList.forEach((ee) => (ee.text = ee.name))
        }
      })
      return categoryTree
    },
    categoryTreeActiveTree() {
      const target = this.categoryTree[this.categoryTreeActive] || { childList: [] }
      return target.childList
    }
  },
  methods: {
    show() {
      this.categoryVisibleForMobile = true
    },
    toCategoryDetailForViewAll() {
      console.log('Clicked viewAll for category at index:', this.categoryTreeActive)
      this.toCategoryDetail(this.categoryTree[this.categoryTreeActive])
    },
    toCategoryDetail(category) {
      this.categoryVisibleForMobile = false
      this.$emit('visibleChange', false)
      if (this.$route.path === '/commodity/category-detail') {
        return bus.$emit('mobileCategoryChange', category)
      }
      if (this.$route.path === '/product-list') {
        return bus.$emit('mobileCategoryChange', category)
      }
      // this.$router.push({
      //   path: '/content/product-list',
      //   query: {
      //     categoryId: category.categoryId
      //   }
      // })
      location.href = '/product-list/' + category.categoryUrl
    }
  }
}
</script>

<style lang="scss" scoped>

.categoryPopupContent {
    padding: 0.28rem .32rem;
    .second_item {
      .second_item_name {
        width: 80%;
        font-size: 16px;
        font-family: Poppins, Poppins;
        font-weight: 600;
        color: #303133;
        line-height: 20px;
        font-style: normal;
        margin-top: 0.11rem;
      }
      .second_item_arrow {
        margin-right: 10px; /* 新增样式 */
      }
    }
    .item {
      width: 33.3%;
      margin: 0 0 0.3rem 0;      // display: inline-block;
      display: flex;
      flex-direction: column;
      >.image {
        width: 80%;
        flex-shrink: 0;
        margin: 0 auto;
        >img {
          width: 100%;
          border-radius: 50%;
        }
      }
      .item_name {
        color: #303133;
        text-align: center;
        font-size: 12px;
        width: 100%;
      }
    }
  }
  .viewAll{
    color: #9AC331;
    margin-bottom: 20px;
    font-size: 12px;
  }

/deep/ .van-sidebar {
  width: 1.8rem;
  flex: unset !important;
}

/deep/ .van-sidebar-item__text {
  font-size: 12px;
  color: #909399;
  word-break:keep-all;
}
/deep/ .van-sidebar-item--select::before{
  background-color: #9AC331;
  height: 1.25rem;
}
/deep/ .van-popup__close-icon{
  color: #909399;
  font-size: 24px;
}
/deep/ .van-popup__close-icon--top-right {
  top: 0.2rem;
}
/deep/ .van-tree-select__nav{
  background-color: #F5F7F7;
}
/deep/ .van-sidebar-item--select{
  font-weight: 600;
  word-break:keep-all;
  .van-sidebar-item__text {
    color: #303133;
  }
}
/deep/ .van-tree-select{
  border-top: 1px solid #EFF1F7;
}
</style>
